import React from "react";
import PageHeader from "../Common/PageHeader";
import SettingsLinks from "./SettingsLinks";
import SettingsIcon from "../../assets/icons/nav_settings.svg2";

export default function SettingsLandingPage() {
  return (
    <div>
      <PageHeader
        Icon={SettingsIcon}
        heading="Settings"
        subheading="All of the system settings for your account."
      />
      <SettingsLinks />
    </div>
  );
}
